<!-- svelte-ignore css-unused-selector -->
<svelte:options tag="telelife-evolution" />

<script lang="ts">
	import {onDestroy, onMount} from "svelte";
	import {InsuredDetails} from "./models";
	import ElectronicConsent from "./components/ElectronicConsent.svelte";
	import {NavigationState} from "./models/NavigationState";
	import {parseApplicationData,
		getApplicationsForUser, storeUserApplicationList, applicationSelected
	} from "./services/ApplicationDataService";
	import {ApplicationData} from "./models/ApplicationData";
	import {
		StoredApplicationData, StoredApplicationDataList,
		ApplicationId, Disclosures, EzAppBaseUrl,
		StoredAuthToken, FatalError
	} from "./services/Store";

	import {
		getDisclosureList,
	} from "./services/QuestionDataService";
	import NavigationContainer from "./components/NavigationContainer.svelte";

	let navigationState = new NavigationState();
	let insured = new InsuredDetails();
	navigationState.dashboard = true;
	export let ezappapi = process.env.NODE_ENV;
	export  let cssUrl = process.env.CssUrl;
	export let jwt = "Not set";
	StoredAuthToken.set("bearer " + jwt);
	let rootElement;
	let applicationData: ApplicationData;
	const applicationDataUnsubscribe = StoredApplicationData.subscribe(value => applicationData = value);
	onDestroy(applicationDataUnsubscribe)

	let applicationId = $ApplicationId || '';
	let policyNumber = '';

	onMount(() => {
		EzAppBaseUrl.set('process.env.EZAppAPIBaseUrl');
		$FatalError = false;
		const stylesheets = [
			process.env.CssUrl + 'bundle.css'
		];
		stylesheets.forEach((s) => {
			const e = document.createElement("link");
			e.setAttribute("rel", "stylesheet");
			e.setAttribute("type", "text/css");
			e.setAttribute("href", s);
			rootElement.appendChild(e);
		});

		getApplicationsForUser().then(applicationData => { storeUserApplicationList(applicationData); });
		getDisclosureList().then(disclosures => Disclosures.set(disclosures));
	});



   const applicationSelectCompleted = (event: any) => {
	    if (event) {
	    const applicationId = event.detail.applicationId;
			if (applicationId) {
	        applicationSelected(applicationId);
	    	}
		}
   }
   const applicationIdBubbleFromNavigation = (event: any) => {
		if (event && event.detail) {
			const applicationId = event.detail;
			if (applicationId) {
				applicationSelected(applicationId);
			}
		}
   }



</script>

<svelte:head>
	<link href="https://fonts.googleapis.com/icon?family=Material+Icons" rel="stylesheet">

	<script>
		window['_fs_debug'] = false;
		window['_fs_host'] = 'fullstory.com';
		window['_fs_script'] = 'edge.fullstory.com/s/fs.js';
		window['_fs_org'] = 'TSE6E';
		window['_fs_namespace'] = 'FS';
		(function(m,n,e,t,l,o,g,y){
			if (e in m) {if(m.console && m.console.log) { m.console.log('FullStory namespace conflict. Please set window["_fs_namespace"].');} return;}
			g=m[e]=function(a,b,s){g.q?g.q.push([a,b,s]):g._api(a,b,s);};g.q=[];
			o=n.createElement(t);o.async=1;o.crossOrigin='anonymous';o.src='https://'+_fs_script;
			y=n.getElementsByTagName(t)[0];y.parentNode.insertBefore(o,y);
			g.identify=function(i,v,s){g(l,{uid:i},s);if(v)g(l,v,s)};g.setUserVars=function(v,s){g(l,v,s)};g.event=function(i,v,s){g('event',{n:i,p:v},s)};
			g.anonymize=function(){g.identify(!!0)};
			g.shutdown=function(){g("rec",!1)};g.restart=function(){g("rec",!0)};
			g.log = function(a,b){g("log",[a,b])};
			g.consent=function(a){g("consent",!arguments.length||a)};
			g.identifyAccount=function(i,v){o='account';v=v||{};v.acctId=i;g(o,v)};
			g.clearUserCookie=function(){};
			g.setVars=function(n, p){g('setVars',[n,p]);};
			g._w={};y='XMLHttpRequest';g._w[y]=m[y];y='fetch';g._w[y]=m[y];
			if(m[y])m[y]=function(){return g._w[y].apply(this,arguments)};
			g._v="1.3.0";
		})(window,document,window['_fs_namespace'],'script','user');
	</script>

</svelte:head>
<main bind:this={rootElement} >
	{#if !navigationState.electronicConsentReceived}
		<ElectronicConsent on:electronicConsentChanged={() => (navigationState.electronicConsentReceived = true)}
			disabled = {false} />
		{:else}
		{#if $FatalError}
			<div class="fatal-error">
				<h3>
					<p>We are sorry, an error has occurred.</p>
					<p>Please contact 1-800-366-9378, Option 1 for assistance.</p>
					<p>Our hours of operations are central times 7:30am-6pm Monday thru Thursday, and 7:30am-5pm Friday.</p>
				</h3>
			</div>
		{/if}

		{#if !$FatalError}
		<NavigationContainer applicationData="{applicationData}" on:applicationSelected={applicationIdBubbleFromNavigation} />
			{/if}
{/if}

</main>

<style lang="scss">
@use "../component_scss_library/colors" as colors;
@use "../component_scss_library/fonts" as fonts;

main {
    text-align: center;
    padding: 0 1em;
    max-width: 240px;
}
h1 {
    color: colors.$primary;
    @include fonts.primary;
    font-size: 4em;
    font-weight: 100;
}
.fatal-error {
	@include fonts.primary;
}

@media (min-width: 640px) {
    main {
        max-width: none;
		}
	}
	@media (max-width: 414px) {
		main {
			padding: 0 0 0 1.5em;
    }
}
textarea {
    padding: 2px;
    @include fonts.primary;
}
ul {
    list-style: none;
}
hr.lightHr {
    border: 1px solid colors.$accent-light-blue;
}
</style>
